const store = {
    namespaced: true,
    state() {
        return {
            showDrawer: false,
            showSearch: false,
            showCart: false,
            modal: {
                auth: false,
                register: false,
                grinding: false,
                restorePassword: false,
                sendRequestRecoveryPassword: false,
                authSuccess: false,
                authCode: false,
                profile: false,
                filters: false,
                pageFilters: false,
                grinding: false,
                selectGoods: false,
                city: false,
                deliveryType: false,
                warehouse: false,
                postmachine: false,
                address: false,
                branche: false,
                bonuses: false,
                promocode: false,
                promocodeData: false,
                news: false
            },
            settings: {
                address: {},
                currency: {
                    code: null,
                    symbol: null
                },
                important_message: null,
                login: {
                    email: false,
                    sms: false
                },
                online_payment_on: false,
                payment_methods: []
            },
            pages: [],
            phoneMask: {
                input: '+38 ### ###-##-##',
                masked: '+## ### ###-##-##',
                focus: '+38 '
            },
            currency: null,
            countryAlert: null
        };
    },
    getters: {
        getShowDrawer(state) {
            return state.showDrawer;
        },
        getShowSearch(state) {
            return state.showSearch;
        },
        getShowCart(state) {
            return state.showCart;
        },
        getModal(state) {
            return state.modal;
        },
        getSettings(state) {
            return state.settings;
        },
        getPages(state) {
            return state.pages;
        },
        getPhoneMask(state) {
            return state.phoneMask;
        },
        getCurrency(state) {
            return state.currency;
        },
        getCountryAlert(state) {
            return state.countryAlert;
        }
    },
    mutations: {
        toggleDrawer(state, show) {
            state.showDrawer = show;
            toggleDocumentScroll(show);
        },
        toggleSearch(state, show) {
            state.showSearch = show;
            toggleDocumentScroll(show);
        },
        toggleCart(state, show) {
            state.showCart = show;
            toggleDocumentScroll(show);
        },
        toggleModal(state, modal) {
            state.modal[modal.name] = modal.show;
            toggleDocumentScroll(modal.show);
        },
        setSettings(state, data) {
            state.settings = data;
        },
        setPages(state, data) {
            state.pages = data;
        },
        setPhoneMask(state) {
            state.phoneMask = {
                input: '+48 ## ###-##-##',
                masked: '+## ## ###-##-##',
                focus: '+48 '
            };
        },
        setCurrency(state, currency) {
            state.currency = currency;
        },
        setCountryAlert(state, payload) {
            state.countryAlert = payload;
        }
    },
    actions: {
        getCurrency({ commit, rootGetters }) {
            const settings = rootGetters['global/globalSettings'];

            const currency = settings?.project_currency?.toUpperCase() || '';
            commit('setCurrency', currency);
        },
        getSettings({ commit }) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .get('/api/v1/settings')
                    .then(response => {
                        commit('setSettings', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        getPages({ commit }) {
            return new Promise((resolve, reject) => {
                this.$axios
                    .get('/api/v1/pages')
                    .then(response => {
                        commit('setPages', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        }
    }
};

const toggleDocumentScroll = blocked => {
    if (blocked) {
        document.documentElement.classList.add('is-clipped');
    } else {
        document.documentElement.classList.remove('is-clipped');
    }
};

export default store;
